(function(){
  var ANAHTAR = "vl_yorum_onizleme", acik = false;
  try {
    if (location.search.indexOf("onizlekapat") > -1) { sessionStorage.removeItem(ANAHTAR); }
    else if (location.search.indexOf("onizle") > -1) { sessionStorage.setItem(ANAHTAR, "1"); }
    acik = sessionStorage.getItem(ANAHTAR) === "1";
  } catch (e) {}
  if (!acik) return;
  document.documentElement.classList.add("vl-yorum-onizleme-aktif");

  var YILDIZ = "<svg class=\"vo-yildiz\" width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"currentColor\" aria-hidden=\"true\"><path d=\"M12 2.5l2.9 6.2 6.6.9-4.8 4.7 1.2 6.7L12 17.8 6.1 21l1.2-6.7L2.5 9.6l6.6-.9z\"/></svg>";
  function yildizlar(n) { var s = ""; for (var i = 0; i < n; i++) { s += YILDIZ; } return s; }

  function gorseller() {
    var out = [], im = document.querySelectorAll(".main-product__media-wrapper img, .product__media img");
    for (var i = 0; i < im.length && out.length < 5; i++) {
      var s = im[i].currentSrc || im[i].src;
      if (s && out.indexOf(s) === -1) { out.push(s); }
    }
    return out;
  }

  var YORUMLAR = [
  { a: "Nazan", t: "3 gün önce", b: "", m: "İşçilik, malzeme kalitesi gerçekten her şeyiyle dört dörtlük olmuş. Normalde kılıfla telefon kullanamazdım ama hissiyatı tam beklediğim gibi, çok memnunum.", p: 5 },
  { a: "Yusuf", t: "1 hafta önce", b: "", m: "Ben bu kadar özenle yapılmış bir ürün kargo görmedim. Bir tane daha alacağım, ellerinize sağlık, bol kazançlar.", p: 5 },
  { a: "Esra", t: "2 hafta önce", b: "", m: "Gönderdiğiniz görseller güzeldi ama canlısı bambaşka. Bayıldım, ellerinize sağlık.", p: 5 },
  { a: "", t: "2 hafta önce", b: "", m: "Tek kusurunuz mükemmel olmanız. Teşekkür ederim, bu sizden aldığım ikinci ürün. Çok başarılı.", p: 5 },
  { a: "Damla", t: "3 hafta önce", b: "", m: "Ürün elime ulaştı, çok beğendim. Özverinize çok teşekkür ederim, gerçekten işinizi hakkıyla yapıyorsunuz.", p: 5 },
  { a: "Erdem", t: "1 ay önce", b: "", m: "Çok teşekkür ederim, ürünler elime ulaştı. Çok memnun kaldım, mükemmel kalite.", p: 5 },
  { a: "", t: "1 ay önce", b: "", m: "Biraz gecikti ama ürün çok güzel, elinize sağlık, teşekkür ediyorum. Herkese de tavsiye ederim.", p: 3 },
  { a: "Sümeyra", t: "2 ay önce", b: "", m: "Kaliteli bir alışveriş oldu. Kılıfım geldi, gerçekten çok güzel.", p: 4 }
  ];

  function kur() {
    var oz = document.querySelector(".vl-jdgm-ozet");
    if (oz && !oz.querySelector(".vo-ozet")) {
      oz.innerHTML = "<button type=\"button\" class=\"vo-ozet vo-ozet--tik\">" + yildizlar(5) + " <b>4,6</b> <span>· 171 değerlendirme</span></button>";
    }
    var kartlar = document.querySelectorAll(".vl-jdgm-kart");
    var adetler = [12, 7, 23, 5, 31, 9];
    for (var k = 0; k < kartlar.length; k++) {
      if (kartlar[k].querySelector(".vo-ozet")) { continue; }
      kartlar[k].innerHTML = "<span class=\"vo-ozet vo-ozet--kart\">" + yildizlar(5) + " <span>(" + adetler[k % 6] + ")</span></span>";
    }
    var alan = document.querySelector(".vl-jdgm-alan");
    if (alan && !alan.querySelector(".vo-blok")) {
      var g = gorseller(), serit = "";
      for (var i = 0; i < g.length; i++) {
        serit += "<div class=\"vo-foto\" style=\"background-image:url(" + g[i] + ")\"></div>";
      }
      var kart = "";
      for (var j = 0; j < YORUMLAR.length; j++) {
        var y = YORUMLAR[j];
        kart += "<div class=\"vo-yorum\"><div class=\"vo-yorum__ust\">" + yildizlar(y.p || 5)
          + "<span class=\"vo-rozet\">Doğrulanmış alıcı</span></div><div class=\"vo-yorum__kim\">" + (y.a || "Anonim")
          + " <span>· " + y.t + "</span></div>" + (y.b ? "<div class=\"vo-yorum__bas\">" + y.b : "<div style=\"display:none\">")
          + "</div><div class=\"vo-yorum__met\">" + y.m + "</div></div>";
      }
      alan.innerHTML = "<div class=\"vo-blok\"><div class=\"vo-etiket\">ÖRNEK GÖRÜNÜM — gerçek yorum değil</div><div class=\"vo-baslik\">Müşteri Değerlendirmeleri</div><div class=\"vo-usthat\"><span class=\"vo-puan\">4,6</span>"
        + yildizlar(5)
        + "<span class=\"vo-adet\">171 değerlendirme</span><button type=\"button\" class=\"vo-buton\">Değerlendirme yazın</button></div>"
        + (serit ? "<div class=\"vo-serit\">" + serit + "</div>" : "")
        + kart + "</div>";
    }
    if (!document.getElementById("vl-onizleme-serit") && document.body) {
      var d = document.createElement("div");
      d.id = "vl-onizleme-serit";
      d.innerHTML = "ÖRNEK ÖNİZLEME — bu alanları sadece sen görüyorsun <a href=\"?onizlekapat\">kapat</a>";
      document.body.appendChild(d);
    }
  }

  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) { return; }
    if (!e.target.closest(".vo-ozet--tik")) { return; }
    var h = document.querySelector(".vl-jdgm-alan");
    if (!h) { return; }
    e.preventDefault();
    var bas = document.querySelector("header, .header, .section-header");
    var pay = bas ? bas.getBoundingClientRect().height + 16 : 24;
    var hedef = Math.max(0, window.pageYOffset + h.getBoundingClientRect().top - pay);
    try { window.scrollTo({ top: hedef, behavior: "smooth" }); } catch (err) { window.scrollTo(0, hedef); }
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - hedef) > 80) { window.scrollTo(0, hedef); }
    }, 500);
  }, true);

  var bekle = null;
  var goz = new MutationObserver(function () {
    if (bekle) { return; }
    bekle = setTimeout(function () { bekle = null; kur(); }, 150);
  });
  function gozle() {
    var h = document.querySelectorAll(".vl-jdgm-ozet, .vl-jdgm-alan, .vl-jdgm-kart");
    for (var i = 0; i < h.length; i++) { goz.observe(h[i], { childList: true, subtree: true }); }
  }
  function basla() { kur(); gozle(); }
  if (document.readyState !== "loading") { basla(); } else { document.addEventListener("DOMContentLoaded", basla); }
  setTimeout(basla, 800);
  setTimeout(basla, 2000);
  setTimeout(basla, 4000);
})();